// extracted by mini-css-extract-plugin
module.exports = {"introText":"intro-text_introText__gPxmM"};